import React, { useState, useEffect } from "react";
import Button from "@components/Button";
import CustomInput, { CustomSelectInput } from "@components/CustomInput/CustomInput";
import TableComponent from "@components/TableComponent/TableComponent";
import { Home } from "@mui/icons-material";
import { useNavigate } from "react-router";
import styles from "./TicketSupportPage.module.css";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import TicketUpdateComponent from "@components/TicketUpdate/TicketUpdateComponent";
import useTicket from "@hooks/useTicket";
import { useSelector } from "react-redux";

const TicketSupport = () => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [step, setStep] = useState("manage");
  const [rows, setRows] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    id: "",
    userType: "",
    currentStage: "created",
    firstName: "",
    startDate: null,
    endDate: null,
    type: "report",
    source: "",
  });
  const [showTicketUpdate, setShowTicketUpdate] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const { handleGetSupportTicket } = useTicket();
  const { ticketData } = useSelector((state) => state.ticket);
  const [refreshTickets, setRefreshTickets] = useState(false);

  useEffect(() => {    
      handleGetSupportTicket({ 
        ...searchFilters,
        page: page + 1, 
        limit: rowsPerPage 
      });
    }, [refreshTickets, page, rowsPerPage]);

  const handleSearchInput = ({ target }) => {
    const { name, value } = target;
    setSearchFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenTicketUpdate = (doctor) => {
    setSelectedTicket(doctor);
    setShowTicketUpdate(true);
  };

  const handleNavigateViewTicket = (user) => {
    navigate("/ticketsupport/viewticket", {
        state: { stages: user }
    });
  };


  const createData = (id, userType, firstName, user) => {
    return {
      id,
      userType,
      firstName,
      move: (
        <KeyboardDoubleArrowRightIcon 
          sx={{ fontSize: "2.5rem", backgroundColor:"#000", color:"#ffff", borderRadius:"50%", cursor:"pointer" }}
          onClick={() => handleOpenTicketUpdate(user)}
        />
      ),
      view: (
        <Button
          text="View >"
          onClick={() => handleNavigateViewTicket(user)}
        />
      ),
    };
  };

  useEffect(() => {
    if (Array.isArray(ticketData?.data)) {
      setRows(ticketData.data.map((ticket) => 
        createData(ticket.id, ticket.userType, ticket.firstName, ticket)
      ));
    }
    else{
      setRows([]);
    }
  }, [ticketData]);


  const columns = [
    { id: "id", label: "Id", minWidth: 150 },
    { id: "userType", label: "User", minWidth: 150 },
    { id: "firstName", label: "First Name", minWidth: 150 },
    {
        id: "move",
        label: "Move",
        minWidth: 100,
        align: "left"
    },
    {
      id: "view",
      label: "View",
      minWidth: 100,
      align: "left"
    },
  ];

  const handleNavigateDashboard = () => {
    navigate("/");
  };

  const handleNavigateViewProgress = () => {
    navigate(`/ticketsupport/viewprogress`);
  };

  const tableHeads = [
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="id"
          value={searchFilters.id}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="userType"
          value={searchFilters.userType}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="firstName"
          value={searchFilters.firstName}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
          <div></div>
      ),
    } 
  ];

  const searchFunction = () => {    
    handleGetSupportTicket(searchFilters);
  };

  return (
    <>
        <div className={styles.MenuWrapper}>
            <div className={styles.NavigationWrapper}>
                <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
                <div>
                <span
                className={styles.DashboardText}
                onClick={handleNavigateDashboard}
                >
                Dashboard
                </span>
                <span className={styles.RouteText}>/Ticket Support</span>
                </div>
            </div>
            <div className={styles.ActionItemsWrapper}>
            <Button
                className={styles.BtnClass}
                text={"View Progress"}
                btnType={"secondary"}
                onClick={handleNavigateViewProgress}
            />
            </div>
        </div>
        <div className={styles.searchWrapper}>
            <CustomSelectInput
                className={styles.CustomSelect}
                selectOptions={[
                  { option: "Report", value: "report" },
                  { option: "Contact", value: "contact" },
                ]}
                name={"type"}
                value={searchFilters.type}
                onChange={handleSearchInput}
                defaultOption={"Type"}
            />
            <CustomSelectInput
                className={styles.CustomSelect}
                selectOptions={[
                  { option: "Doctor", value: "doctor" },
                  { option: "Patient", value: "patient" },
                ]}
                name={"userType"}
                value={searchFilters.userType}
                onChange={handleSearchInput}
                defaultOption={"User Type"}
            />
            <CustomSelectInput
                className={styles.CustomSelect}
                selectOptions={[
                  { option: "Vision Therapy App", value: "VisionTherapyApp" },
                  { option: "Vision Management App", value: "VisionManagementApp" },
                  { option: "Chart App", value: "ChartApp" },
                ]}
                value={searchFilters.source}
                onChange={handleSearchInput}
                name={"source"}
                defaultOption={"Source"}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                label="Start Date"
                className={styles.dateInput}
                value={searchFilters.startDate}
                onChange={(value) => setSearchFilters((prev) => ({ ...prev, startDate: value }))}
                renderInput={(params) => <TextField {...params} />}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                label="End Date"
                className={styles.dateInput}
                value={searchFilters.endDate}
                onChange={(value) => setSearchFilters((prev) => ({ ...prev, endDate: value }))}
                renderInput={(params) => <TextField {...params} />}
                />
            </LocalizationProvider>
            <Button
                className={styles.CustomSelect}
                text={"Search"}
                onClick={searchFunction}
                btnType={"primary"}
            />
        </div>
        <TableComponent
            tableHeads={tableHeads}
            columns={columns}
            rows={rows?? []}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            page={page}
            setPage={setPage}
            totalRecords={ticketData?.total_record ?? 0}
            searchFunction={searchFunction}
        />
        {showTicketUpdate && selectedTicket && (
          <div className={styles.modalOverlay} >
            <TicketUpdateComponent
              user = {selectedTicket}
              type = {searchFilters.type}
              setUpdate={setShowTicketUpdate}
              refreshTickets={setRefreshTickets}
            />
          </div>
        )}
    </>
  )
};

export default TicketSupport;